import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import useEnumData from "../../../utils/enums";
import SectionService from "../../../services/srv-section/SectionService";
import EventTypeService from "../../../services/srv-event/EventTypeService";
import {
  FormDateTimePicker,
  FormDropDownList,
  FormInput,
  FormNumericTextBox,
  FormTextArea,
} from "../../../components/sys-form/FormComponents";
import { Field } from "@progress/kendo-react-form";
import { requiredValidator } from "../../../components/sys-form/FormValidators";

export const EventFormMainInfo = ({ formRenderProps, initialValues }) => {
  const { t } = useTranslation();
  const { DATADOMESTICINTERNATIONAL } = useEnumData();
  const [sectionData, setSectionData] = useState([]);
  const [eventTypeData, setEventTypeData] = useState([]);

  useEffect(() => {
    SectionService.getList().then((data) => {
      setSectionData(data);
    });
  }, []);

  useEffect(() => {
    EventTypeService.getListByBolumKodu(
      formRenderProps.valueGetter("boluM_KODU")
    ).then((data) => {
      setEventTypeData(data);
    });
  }, [formRenderProps.valueGetter("boluM_KODU")]);

  return (
    <div>
      <Field
        name="etkinliK_ADI"
        id="etkinliK_ADI"
        label={t("event_name")}
        component={FormInput}
        validator={(value) => requiredValidator(value, t)}
      />
      <Field
        name="boluM_KODU"
        id="boluM_KODU"
        label={t("section")}
        component={FormDropDownList}
        data={sectionData}
        textField="boluM_ADI"
        valueField="boluM_KODU"
        validator={(value) => requiredValidator(value, t)}
        value={formRenderProps.valueGetter("boluM_KODU")}
        onChange={(e) => {
          formRenderProps.onChange("boluM_KODU", {
            value: e.value.boluM_KODU,
          });
        }}
      />
      <Field
        id="etkinliK_TIPI_KODU"
        name="etkinliK_TIPI_KODU"
        label={t("event_type")}
        component={FormDropDownList}
        data={eventTypeData}
        textField="etkinliK_TIPI_ADI"
        valueField="etkinliK_TIPI_KODU"
        validator={(value) => requiredValidator(value, t)}
        disabled={!formRenderProps.valueGetter("boluM_KODU")}
        value={formRenderProps.valueGetter("etkinliK_TIPI_KODU")}
        onChange={(e) =>
          formRenderProps.onChange("etkinliK_TIPI_KODU", {
            value: e.value.etkinliK_TIPI_KODU,
          })
        }
      />
      {/* <Field
        name="etkinliK_TARIHI_BASLIK"
        id="etkinliK_TARIHI_BASLIK"
        label={t("event_date_title")}
        component={FormInput}
        validator={(value) => requiredValidator(value, t)}
      /> */}
      <Field
        name="baS_TAR"
        id="baS_TAR"
        label={t("start_date")}
        component={FormDateTimePicker}
        validator={(value) => requiredValidator(value, t)}
        value={formRenderProps.valueGetter("baS_TAR")}
      />
      <Field
        name="biT_TAR"
        id="biT_TAR"
        label={t("end_date")}
        component={FormDateTimePicker}
        validator={(value) => requiredValidator(value, t)}
        value={formRenderProps.valueGetter("biT_TAR")}
      />
      {/* <Field
        id="kuruM_TAKVIMINDE_GORUNSUN"
        name="kuruM_TAKVIMINDE_GORUNSUN"
        label={t("is_show_company_calendar")}
        component={FormDropDownList}
        data={DATAYESNO}
        textField="text"
        valueField="value"
        validator={(value) => requiredValidator(value, t)}
        value={formRenderProps.valueGetter("kuruM_TAKVIMINDE_GORUNSUN")}
        onChange={(e) =>
          formRenderProps.onChange("kuruM_TAKVIMINDE_GORUNSUN", {
            value: e.value.value,
          })
        }
      /> */}
      <Field
        id="yurticI_YURTDISI"
        name="yurticI_YURTDISI"
        label={t("region")}
        component={FormDropDownList}
        data={DATADOMESTICINTERNATIONAL}
        textField="text"
        valueField="value"
        validator={(value) => requiredValidator(value, t)}
        value={formRenderProps.valueGetter("yurticI_YURTDISI")}
        onChange={(e) =>
          formRenderProps.onChange("yurticI_YURTDISI", {
            value: e.value.value,
          })
        }
      />
      <Field
        id="misafiR_SAYISI"
        name="misafiR_SAYISI"
        label={t("count_of_guests")}
        component={FormNumericTextBox}
        format="n0"
        min={0}
        // validator={(value) => requiredValidator(value, t)}
      />
      <Field
        id="aciklama"
        name="aciklama"
        label={t("description")}
        component={FormTextArea}
        rows={3}
      />
    </div>
  );
};
